// import * as Yup from 'yup'
import { object, string } from 'yup'

export const getSigninSchema = () =>
  object().shape({
    username: string()
      .label('E-Mail')
      .email()
      .required(),
    password: string()
      .label('Пароль')
      .required(),
  })
